<template>
  <el-col :span="12" :xs="24" :sm="24" :md="12" class="miniroom-warpper">
    <div class="miniroom-container" :class='{ "locked": getRoomIsLock && !getModEdition }' @click="setRoom(room.id)">
      <el-row>
        <el-col :span="14" class="miniroom-desc">
          <div :class='{ "miniroom-title-alone": getModEdition }'>{{ room.name }}</div>
          <div v-if="!getModEdition">{{ getOccupationByServiceAndDayRoom(getSelectedDay, getSelectedMainService,
            room.id)}} / {{ getRoomNbCouverts }} couverts</div>
          <div v-if="!getModEdition">Tables {{ getRoomStartId }} à {{ getRoomNbEndId }}</div>
          <div v-if="!getModEdition">Occupation : {{ getOccupation }} %</div>
          <div v-if="!getModEdition" class="miniroom-lock-container">
            <el-popover placement="top" width="200" v-model="popupValid2" popper-class="popup-delete black-inputs">
              <p>
                Êtes vous sûr de vouloir<br>
                {{ (getRoomIsLock) ? 'ouvrir' : 'fermer' }} la salle
              </p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" class="dark" type="primary" @click.stop="popupValid2 = false">Annuler</el-button>
                <el-button type="primary" size="mini" @click.stop="lockUnlockRoom()">Confirmer</el-button>
              </div>
            </el-popover>
            <div class="miniroom-lock-btn" @click.stop="popupValid2 = true" :class='{ "locked": getRoomIsLock }'></div>
          </div>
        </el-col>
        <el-col :span="10">
          <v-stage class="miniroom-canvas" :config="configMiniStage">
            <v-layer ref="miniLayer" :config="configMiniLayer">
              <mini-table v-for="table in tables" :key="table.id" :table="table"></mini-table>
            </v-layer>
          </v-stage>
        </el-col>
      </el-row>
      <div class="miniroom-services" v-if="!getModEdition">
        <el-row :gutter="10">
          <el-col :span="24">
            <div class="miniroom-service-container">
              <div class="miniroom-service">
                <services-mini :ref="'minis-' + getSelectedMainService + '-' + room.id" :room="room"
                  :ms="getSelectedMainService" :date="getSelectedDay"></services-mini>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="getRoomIsLock && !getModEdition" class="miniroom-lock-col"></div>
    </div>
  </el-col>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ServicesMini from '../services/ServicesMini.vue';
import MiniTable from './MiniTable';

export default {
  name: 'MiniRoom',
  components: { MiniTable, ServicesMini },
  props: ['room'],
  data() {
    return {
      configMiniStage: {
        width: 125,
        height: 125
      },
      configMiniLayer: {
        draggable: false,
        listening: false
      },
      configBckg: {
        x: 0,
        y: 0,
        width: 125,
        height: 125,
        fill: '#303B5E'
      },
      popupValid: false,
      popupValid2: false,
      miniLayerDatas: {},
      occupationByRoom: {}
    }
  },
  computed: {
    ...mapGetters({
      getRoomsDatas: 'newRooms/getRoomsDatas',
      getModEdition: 'newRooms/getModEdition',
      getRoomNbCouvertsBookedById: 'newRooms/getRoomNbCouvertsBookedById',
      getRoomNbCouvertsLocked: 'newRooms/getRoomNbCouvertsLocked',
      getRoomIsLocked: 'newRooms/getRoomIsLocked',
      getOccupationByServiceAndDayRoom: 'newReservations/getOccupationByServiceAndDayRoom',
      getMainServicesForDay: 'newServices/getMainServicesForDay',
      getSelectedMainService: 'newServices/getSelectedMainService',
      getSelectedDay: 'calendar/getSelectedDay',
      getDateToTimestamp: 'calendar/getDateToTimestamp',
      getUnitTable: 'newRooms/getUnitTable'
    }),
    getRoomNbCouverts: function () {
      if (this.getRoomsDatas[this.room.id] !== undefined) {
        let nbLockedCouv = this.getRoomNbCouvertsLocked({
          date: this.getSelectedDay,
          service: this.getSelectedMainService,
          room: this.room.id
        })
        return this.getRoomsDatas[this.room.id].nbCouverts - nbLockedCouv
      }
      return 0
    },
    getOccupation: function () {
      if (this.getRoomsDatas[this.room.id] !== undefined) {
        let nbLockedCouv = this.getRoomNbCouvertsLocked({
          date: this.getSelectedDay,
          service: this.getSelectedMainService,
          room: this.room.id
        })
        return Math.round((this.getOccupationByServiceAndDayRoom(this.getSelectedDay, this.getSelectedMainService, this.room.id) / (this.getRoomsDatas[this.room.id].nbCouverts - nbLockedCouv)) * 100)
      }
      return 0
    },
    getRoomStartId: function () {
      if (this.getRoomsDatas[this.room.id] !== undefined) return this.getRoomsDatas[this.room.id].idStart
      return 0
    },
    getRoomNbEndId: function () {
      if (this.getRoomsDatas[this.room.id] !== undefined) return this.getRoomsDatas[this.room.id].idEnd
      return 0
    },
    getRoomIsLock: function () {
      return this.getRoomIsLocked({
        ts: parseInt(this.getDateToTimestamp(this.getSelectedDay)),
        room: this.room.id,
        service: this.getSelectedMainService
      })
    },
    tables: function () {
      if (this.getRoomsDatas[this.room.id] !== undefined) {
        let tables = []
        if (this.getRoomsDatas[this.room.id].tables !== null && this.getRoomsDatas[this.room.id].tables !== undefined) {
          Object.entries(this.getRoomsDatas[this.room.id].tables).forEach(([tid, table]) => {
            tables.push(table)
          })
        }
        return tables
      }
      return 0
    }
  },
  watch: {
    // to fit the room to the 100 x 100 canvas
    'miniLayerDatas': function (val, oldVal) {
      this.fitMiniRoom()
    }
  },
  updated: function () {
    this.fitMiniRoom()
  },
  mounted: function () {
    this.miniLayerDatas = this.$refs['miniLayer'].getStage().getClientRect()
  },
  methods: {
    ...mapActions({
      createLockedRooms: 'newRooms/createLockedRooms',
      deleteLockedRooms: 'newRooms/deleteLockedRooms',
      loadCurrentSelectRoom: 'newRooms/loadCurrentSelectRoom'
    }),
    ...mapMutations({
      setRightSideLoading: 'displayer/setRightSideLoading'
    }),
    setRoom: function (idR) {
      this.setRightSideLoading(true)
      this.loadCurrentSelectRoom(idR)
    },
    lockUnlockRoom: function () {
      this.popupValid2 = false
      this.popupValid = false
      if (!this.getRoomIsLock) {
        this.createLockedRooms({
          days: [this.getDateToTimestamp(this.getSelectedDay)],
          room: this.room.id,
          service: this.getSelectedMainService
        })
      } else {
        this.deleteLockedRooms({
          days: [this.getDateToTimestamp(this.getSelectedDay)],
          room: this.room.id,
          service: this.getSelectedMainService
        })
      }
    },
    fitMiniRoom: function () {
      if (this.$refs['miniLayer'] !== undefined) {
        // vars
        let kMiniLayer = this.$refs['miniLayer'].getStage()
        // let kOrign = this.$refs['orign'].getStage()
        let rectML = this.getRectTablesBoudingBox()
        // get new scale
        let scale = kMiniLayer.scaleX()
        if (rectML.width !== 0 && (this.configMiniStage.width < rectML.width * scale || this.configMiniStage.height < rectML.height * scale)) {
          if (rectML.height > rectML.width) scale = this.configMiniStage.height / rectML.height
          else scale = this.configMiniStage.width / rectML.width
          kMiniLayer.scale({ x: scale, y: scale })
        }
        // center room
        let realXPosRoom = kMiniLayer.x() + ((rectML.x + (rectML.width / 2)) * scale)
        let difX = (this.configMiniStage.width / 2) - realXPosRoom
        kMiniLayer.x(kMiniLayer.x() + difX)
        let realYPosRoom = kMiniLayer.y() + ((rectML.y + (rectML.height / 2)) * scale)
        let difY = (this.configMiniStage.height / 2) - realYPosRoom
        kMiniLayer.y(kMiniLayer.y() + difY)
      }
    },
    // TODO: move to room store and use it in single room too
    getRectTablesBoudingBox: function () {
      if (this.tables.length > 0) {
        let minX = this.tables[0].x - ((this.tables[0].width / 2) * this.getUnitTable)
        let minY = this.tables[0].y - ((this.tables[0].height / 2) * this.getUnitTable)
        let maxX = this.tables[0].x + ((this.tables[0].width / 2) * this.getUnitTable)
        let maxY = this.tables[0].y + ((this.tables[0].height / 2) * this.getUnitTable)
        this.tables.forEach((table) => {
          let testVal = table.x - ((table.width / 2) * this.getUnitTable)
          if (testVal < minX) minX = testVal

          testVal = table.y - ((table.height / 2) * this.getUnitTable)
          if (testVal < minY) minY = testVal

          testVal = table.x + ((table.width / 2) * this.getUnitTable)
          if (testVal > maxX) maxX = testVal

          testVal = table.y + ((table.height / 2) * this.getUnitTable)
          if (testVal > maxY) maxY = testVal
        })
        return {
          width: maxX - minX,
          height: maxY - minY,
          x: minX,
          y: minY
        }
      } else {
        return {
          width: 0,
          height: 0,
          x: 0,
          y: 0
        }
      }
    }
  }
}
</script>

<style lang="scss"></style>
